import {Popup, Position, ToolbarItem} from 'devextreme-react/popup';
import React, {useRef, useState} from "react";
import {useEEToolContext} from "../contexts/eeToolContext";
import DataGrid, {Column, Editing, Format, Paging, Scrolling, Selection} from "devextreme-react/data-grid";
import {LoadPopupPanel} from "../../../../components";
import {useCompareMaterialOptions} from "../api/compare-material-options";
import {MaterialOption} from "../types/MaterialOption";

export function MaterialOptionsPopupControl(props: {
    visible: boolean,
    total: number,
    qty: number,
    onPopupHidden: () => void
}) {
    const context = useEEToolContext();
    const materialOptionsProducts = useCompareMaterialOptions(context.dealerId, context.materialProducts, context.quoteId ?? '', context.customerZip);

    const getOKButtonOptions = {
        stylingMode: 'contained',
        text: 'OK',
        onClick: () => {
            props.onPopupHidden();
        }
    };

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => {
            props.onPopupHidden();
        }
    };

    if (!props.visible)
        return <></>;

    return (
        <>
            <Popup
                title='Material Options'
                visible={props.visible}
                hideOnOutsideClick={true}
                showCloseButton={true}
                onHidden={() => {
                    props.onPopupHidden()
                }}
            >
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getOKButtonOptions}
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <DataGrid
                    className="product-search-results"
                    dataSource={materialOptionsProducts.data}
                    allowColumnResizing={true}
                    wordWrapEnabled={true}
                    keyExpr={['productLine', 'productType', 'thickness']}
                    repaintChangesOnly={true}
                >
                    <Paging enabled={false}></Paging>
                    <Scrolling rowRenderingMode='virtual'></Scrolling>
                    <Column
                        dataField="productLine"
                        caption="Product Line"
                        dataType="string"
                    />
                    <Column
                        dataField="productType"
                        caption={'Product Type'}
                        dataType="string"
                    />
                    <Column
                        dataField="thickness"
                        caption={'Thickness'}
                        dataType="string"
                        width={120}
                    />
                    <Column
                        dataField={'retailPrice'}
                        caption={'Subtotal'}
                        dataType="number"
                        width={120}
                        calculateCellValue={(row: MaterialOption) => {
                            return props.total + row.price * props.qty
                        }}
                    >
                        <Format type="currency" precision={2}></Format>
                    </Column>
                </DataGrid>
                <LoadPopupPanel visible={materialOptionsProducts.isLoading}></LoadPopupPanel>
            </Popup>
        </>
    );
}
